import type { ReactNode } from "react";
import { ActionButton } from "../ui/action-button";
import { logout } from "../modules/session/session-service";
import { useAppStore } from "./app-store";
import { BottomNavigation } from "./bottom-navigation";

type AppShellProps = {
  children: ReactNode;
};

function errorMessage(error: unknown): string {
  return error instanceof Error ? error.message : "Failed";
}

function Icon({ path }: { path: string }) {
  return (
    <svg aria-hidden="true" className="app-nav-icon" viewBox="0 0 24 24">
      <path d={path} />
    </svg>
  );
}

export function AppShell({ children }: AppShellProps) {
  const selectedTab = useAppStore((state) => state.selectedTab);
  const shellError = useAppStore((state) => state.shellError);
  const platform = useAppStore((state) => state.platform);
  const setSignedOut = useAppStore((state) => state.setSignedOut);
  const setShellError = useAppStore((state) => state.setShellError);

  async function handleLogout(): Promise<void> {
    try {
      await logout();
      setSignedOut();
    } catch (error) {
      setShellError(errorMessage(error));
    }
  }

  return (
    <div className="app-shell" data-device={platform.deviceClass} data-runtime={platform.runtime}>
      <main className="app-main" aria-label="Main content">
        {selectedTab === "account" ? (
          <ActionButton aria-label="Sign out" tone="secondary" onPress={handleLogout}>
            <Icon path="M10 4h10v16H10v-2h8V6h-8zm-2.5 4.5L9 10l-2 2 2 2-1.5 1.5L3 11z" />
          </ActionButton>
        ) : children}
      </main>
      <BottomNavigation />
      {shellError ? <p className="app-toast" role="alert">{shellError}</p> : null}
    </div>
  );
}
